import { render } from "./page3.vue?vue&type=template&id=751c3c24&scoped=true"
import script from "./page3.vue?vue&type=script&lang=js"
export * from "./page3.vue?vue&type=script&lang=js"

import "./page3.vue?vue&type=style&index=0&id=751c3c24&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-751c3c24"]])

export default __exports__